"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCJKLocale = exports.locales = exports.orderedLocales = exports.getDefaultLocale = exports.ordered = void 0;
var arabic_1 = require("./localeDefinitions/arabic");
var chineseSimplified_1 = require("./localeDefinitions/chineseSimplified");
var chineseTraditional_1 = require("./localeDefinitions/chineseTraditional");
var english_1 = require("./localeDefinitions/english");
var french_1 = require("./localeDefinitions/french");
var german_1 = require("./localeDefinitions/german");
var indonesian_1 = require("./localeDefinitions/indonesian");
var italian_1 = require("./localeDefinitions/italian");
var japanese_1 = require("./localeDefinitions/japanese");
var korean_1 = require("./localeDefinitions/korean");
var lao_1 = require("./localeDefinitions/lao");
var malay_1 = require("./localeDefinitions/malay");
var portuguese_1 = require("./localeDefinitions/portuguese");
var russian_1 = require("./localeDefinitions/russian");
var spanish_1 = require("./localeDefinitions/spanish");
var tagalog_1 = require("./localeDefinitions/tagalog");
var thai_1 = require("./localeDefinitions/thai");
var turkish_1 = require("./localeDefinitions/turkish");
var vietnamese_1 = require("./localeDefinitions/vietnamese");
var types_1 = require("./types");
__exportStar(require("./types"), exports);
/**
 * Priority ordered array of locales
 */
exports.ordered = [
    english_1.english,
    japanese_1.japanese,
    korean_1.korean,
    chineseSimplified_1.chineseSimplified,
    chineseTraditional_1.chineseTraditional,
    german_1.german,
    spanish_1.spanish,
    french_1.french,
    italian_1.italian,
    indonesian_1.indonesian,
    malay_1.malay,
    portuguese_1.portuguese,
    russian_1.russian,
    tagalog_1.tagalog,
    thai_1.thai,
    lao_1.lao,
    vietnamese_1.vietnamese,
    arabic_1.arabic
];
/**
 * Returns the correct default locale
 */
function getDefaultLocale(selectableLocales) {
    var locales = selectableLocales ? exports.ordered.filter(function (item) {
        return selectableLocales.find(function (locale) { return locale === item.code; });
    }) : exports.ordered;
    var englishLocale = locales.find(function (locale) { return locale.code === types_1.LocaleCode.English; });
    if (englishLocale)
        return englishLocale;
    var japaneseLocale = locales.find(function (locale) { return locale.code === types_1.LocaleCode.Japanese; });
    if (japaneseLocale)
        return japaneseLocale;
    return locales[0];
}
exports.getDefaultLocale = getDefaultLocale;
/**
 * Priority ordered array of LocaleCodes
 */
exports.orderedLocales = exports.ordered.map(function (locale) { return locale.code; });
/**
 * All locales
 * @type {Object} keys are locale codes, values are Locale objects
 */
exports.locales = (_a = {},
    _a[types_1.LocaleCode.English] = english_1.english,
    _a[types_1.LocaleCode.Japanese] = japanese_1.japanese,
    _a[types_1.LocaleCode.Korean] = korean_1.korean,
    _a[types_1.LocaleCode.ChineseSimplified] = chineseSimplified_1.chineseSimplified,
    _a[types_1.LocaleCode.ChineseTraditional] = chineseTraditional_1.chineseTraditional,
    _a[types_1.LocaleCode.German] = german_1.german,
    _a[types_1.LocaleCode.Spanish] = spanish_1.spanish,
    _a[types_1.LocaleCode.French] = french_1.french,
    _a[types_1.LocaleCode.Italian] = italian_1.italian,
    _a[types_1.LocaleCode.Indonesian] = indonesian_1.indonesian,
    _a[types_1.LocaleCode.Malay] = malay_1.malay,
    _a[types_1.LocaleCode.Portuguese] = portuguese_1.portuguese,
    _a[types_1.LocaleCode.Russian] = russian_1.russian,
    _a[types_1.LocaleCode.Tagalog] = tagalog_1.tagalog,
    _a[types_1.LocaleCode.Thai] = thai_1.thai,
    _a[types_1.LocaleCode.Lao] = lao_1.lao,
    _a[types_1.LocaleCode.Vietnamese] = vietnamese_1.vietnamese,
    _a[types_1.LocaleCode.Arabic] = arabic_1.arabic,
    _a[types_1.LocaleCode.Turkish] = turkish_1.turkish,
    _a);
/**
 * Function to check if a locale is CJK - Chinese/Japanese/Korean.
 * Often logic is set to be different in these three language types as they
 * use chinese characters or their derivatives
 * @param locale
 */
function isCJKLocale(locale) {
    return (locale === types_1.LocaleCode.Japanese ||
        locale === types_1.LocaleCode.Korean ||
        locale === types_1.LocaleCode.ChineseSimplified ||
        locale === types_1.LocaleCode.ChineseTraditional);
}
exports.isCJKLocale = isCJKLocale;
